export default __webpack_public_path__ + "static/media/tiktok.7843e5cd.png";